import { TAB_FLOOR_PLANS, TAB_QUICK_MOVE_INS } from '../constants';

/**
 * Maps this feature's internal tab constants (constants.js) to the wire-format values the
 * tracking spec expects (Confluence 5839192072 / Jira NHS20-8249's AC table: 'floor_plans',
 * 'qmi'). Shared by both segmentEventBuilder.js and googleAnalytics4EventBuilder.js so the two
 * providers can never drift on what the same tab is called.
 * @type {Record<string, string>}
 */
const TAB_TRACKING_VALUES = {
  [TAB_FLOOR_PLANS]: 'floor_plans',
  [TAB_QUICK_MOVE_INS]: 'qmi',
};

/**
 * @param {string|null} tab - one of constants.js's TAB_FLOOR_PLANS/TAB_QUICK_MOVE_INS, or null
 * @returns {string|null}
 */
export default function getTabTrackingValue(tab) {
  return TAB_TRACKING_VALUES[tab] ?? null;
}
